<template>
    <div>

        <NavLinks></NavLinks>
       
        <div class="container-fluid py-4">
            <transition name="fade" mode="out-in">
                <router-view :key="$route.fullPath"/>
            </transition>
        </div>
        
    </div>
</template>

<script>

import NavLinks from '@/views/template/NavLinks.vue';

export default {
    name:  'Template',
    props: [""],
    components:{
        NavLinks,
    },
    data() {
        return {
            SessionStorage: {},
        }
    },
    methods: {
        Getdatauser() { // DATOS DE SESSIÓN 
            this.SessionStorage = JSON.parse(sessionStorage.getItem('user'));
        },
    },
    created() {
        this.Getdatauser();
    },
}
    
</script>
<style>
body.modal-open {
  overflow: hidden;
}
</style>